import { useStandardAgentDisplayName } from "@/modules/standardAgent/useStandardAgentDisplayName";

/**
 * Pulsing dot shown inline on an opportunity card's name line while its primary
 * agent thread is running. Its "‹agent› is working" label is the accessible name
 * and the tooltip. The agent name is resolved from settings (defaults to "Frank").
 */
export function OpportunityWorkingIndicator() {
  const agentName = useStandardAgentDisplayName();
  const label = `${agentName} is working`;

  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className="h-1.5 w-1.5 shrink-0 rounded-full bg-primary animate-pulse"
    />
  );
}
